export default __webpack_public_path__ + "static/media/cake21.c0777654.jpg";